import React, { Component } from 'react';

import Box from '@zacousticrepo/grommet-v1-custom/components/Box';
import SpinningIcon from '@zacousticrepo/grommet-v1-custom/components/icons/Spinning';

class LoadingControl extends Component {
    render() {
        return (
            <Box
                direction="row"
                responsive={false}
                pad={{ between: 'small', horizontal: 'medium', vertical: 'medium' }}>
                <SpinningIcon />
                <span>Loading...</span>
            </Box>
        );
    }
}

export default LoadingControl;
